/**
 * @description 发布Controller
 * @date 2019-03-29
 * @author jywang
 */
import React, { PureComponent } from 'react';
import { toJS } from 'mobx';
import toast from '@util/toast';
import { inject } from 'mobx-react';
import tool from '@util/tool';

const WithPublicQuestionController = (ComponentCon) => {
    @inject('store')
    class PublicQuesitonController extends PureComponent<any, any> {
        constructor(props) {
            super(props);
            this.state = {
                hasClickSubmit: false,
            };
        }
        public componentWillMount() {
            this.props.store.hasLoginManage();
        }
        public render() {
            const newProps = {
                submitBtn: this.submitBtn,
                ...this.state,
            };
            return (
                <ComponentCon {...newProps} />
            );
        }
        public submitBtn = () => {
            this.setState({
                hasClickSubmit: true,
            });
            const { store } = this.props;
            console.log(store.addQuestion);
            const param_box: any = {};
            const param: any = {};
            if (!tool.trimStr(store.addQuestion.name)) {
                toast.error('标题不可为空');
                this.setState({
                    hasClickSubmit: false,
                });
                return;
            } else if (tool.trimStr(store.addQuestion.name).length < 5 || tool.trimStr(store.addQuestion.name).length > 40) {
                toast.error('标题请输入4-40个字符');
                this.setState({
                    hasClickSubmit: false,
                });
                return;
            }
            if (store.addQuestion.content && store.addQuestion.content.length > 10000) {
                toast.error('内容请输入10000个字符以内');
                this.setState({
                    hasClickSubmit: false,
                });
                return;
            }
            if (store.addQuestion.name) {
                const lastChartAt = store.addQuestion.name.charAt(store.addQuestion.name.length - 1);
                if (lastChartAt !== '?' && lastChartAt !== '？') {
                    store.addQuestion.name = store.addQuestion.name + '?';
                }
            }
            param.name = tool.trimStr(store.addQuestion.name);
            param.content = tool.trimStr(store.addQuestion.content);
            if (store.addQuestion.type === 0) {
                if (store.addQuestion.images && store.addQuestion.images.length <= 0 && !store.addQuestion.content) {
                    toast.error('请上传图片或输入问题描述');
                    this.setState({
                    hasClickSubmit: false,
                });
                    return;
                }
                param.images = toJS(store.addQuestion.images);
            } else if (store.addQuestion.type === 1) {
                if (!store.addQuestion.video && !store.addQuestion.content) {
                    toast.error('请上传视频或输入问题描述');
                    this.setState({
                        hasClickSubmit: false,
                    });
                    return;
                }
                param.video = toJS(store.addQuestion.video);
            }
            console.log(param);
            param_box.question = param;
            store.publicQuestion.set_v2(param_box).then((res) => {
                console.log('发布成功====>', res);
                window.location.href = '/question';
            }).catch((err) => {
                toast.error(err.msg);
                this.setState({
                    hasClickSubmit: false,
                });
            });
        }
    }
    return PublicQuesitonController;
};

export default WithPublicQuestionController;
